import { LogisticaTiposEntrega } from "@pcgerente-node/pcg-comun";
import { CIUDAD } from "@pcgerente-node/pcg-comun/dist/DTOs";
import { CSSProperties, ChangeEvent, useEffect } from "react";
import { useSelector } from "react-redux";
import { getAllCities, getCiudadesDestinoDestinatario, getCiudadesOrigenRemitente } from "../../../../redux/actions/actionsCrear";
import { RootState, useAppDispatch } from "../../../../redux/store";
import { ChildProps_logistica_GUIA_PROFORMAviewModel } from "../ContentGuia";

export const StyleProps1: CSSProperties ={
    color: "black"
}
export const StylePropsSelect : CSSProperties ={
    color: "white",
    backgroundColor: "#ff5800",
    border: "1px solid black",
    padding: "4px 4px"
}
export const StyleProps2: CSSProperties = {
    backgroundColor: "#d9d9f3",
    border: "1px solid #304aca",
};

const CiudadesYModoEntrega: React.FC<ChildProps_logistica_GUIA_PROFORMAviewModel> = ({guia, setGuia}) => {
    const ciudadesOrigenStore = useSelector((state: RootState) => state.crear.ciudadesOrigen)
    const ciudadesDestinoStore = useSelector((state: RootState) => state.crear.ciudadesDestino)

    const dispatch = useAppDispatch()
    
    useEffect(() => {
        dispatch(getAllCities())
    },[])

    useEffect(() => {
        if (!ciudadesOrigenStore.errorUndefined && guia.idRemitente !== 0){
            dispatch(getCiudadesOrigenRemitente(guia.idRemitente))
        }
    },[guia.idRemitente])

    useEffect(() => {
        if(!ciudadesOrigenStore.errorUndefined && guia.idRemitente !== 0 && guia.idCiudadOrigen){
            dispatch(getCiudadesDestinoDestinatario(guia.idRemitente, guia.idCiudadOrigen))
        }
    },[ guia.idRemitente, guia.idCiudadOrigen])

    return(
    <>
    <div className="col-md-6">
        <div className="form-group row invoice-created-by">
        <label htmlFor="payment-method-account" className="col-sm-3 col-form-label col-form-label-sm" style={StyleProps1}>Origen:</label>
        <div className="col-sm-6">
        { guia.idRemitente === 0? 
            <span>Seleccione un remitente</span>
            :
            <select name="country_code"
                onChange={(e) => handleInfo(e, "origen")}
                className="form-control country_code  form-control-sm"
                style={StylePropsSelect}
                color="white" id="payment-method-country"
                value={guia.idCiudadOrigen}
            >
                <option value="0" hidden>Ciudad de Origen</option>
                {ciudadesOrigenStore.info?.map(ciudad => {
                    return <option key={ciudad.id} value={ciudad.id}>
                        {ciudad.nombre}
                    </option>

                })}
            </select>
}
        </div>
    </div>

    <div className="form-group row invoice-created-by">
        <label htmlFor="payment-method-bank-name" className="col-sm-3 col-form-label col-form-label-sm" style={StyleProps1}>Destino:</label>
        <div className="col-sm-6">
            {ciudadesDestinoStore?.info?.length>0 ? 
                <select name="country_code"
                onChange={(e) => handleInfo(e, "destino")}
                className="form-control country_code  form-control-sm"
                style={StylePropsSelect}
                color="white" id="payment-method-country"
                value={guia.idCiudadDestino}
            >
                <option value="0" hidden>Ciudad de Destino</option>
                {ciudadesDestinoStore.info?.map(ciudad => {
                    return <option key={ciudad.id} value={ciudad.id}>
                        {ciudad.nombre}
                    </option>
                })}
            </select>
            :
            <span>
                Elija una ciudad de Origen
             </span>
            }
        </div>
    </div>
    <div className="form-group row invoice-created-by">
        <label htmlFor="" className="col-sm-3 col-form-label col-form-label-sm"
            style={StyleProps1}>Entrega:</label>
        <div className="col-sm-6">
            <select name="country_code"
                onChange={(e) => handleInfo(e, "modoEntrega")}
                className="form-control country_code  form-control-sm"
                style={StylePropsSelect}
                color="white" id="payment-method-country"
                value={guia.tipoEntrega}
            >
                <option hidden value="">Escoja tipo de entrega</option>
                <option value={LogisticaTiposEntrega.Domicilio}>A domicilio</option>
                <option value={LogisticaTiposEntrega.RetiroOficina}>Retiro en Oficina</option>
            </select>
        </div>
    </div>
</div>
</>
)
    function handleInfo(e: ChangeEvent<HTMLInputElement | HTMLSelectElement>, type: "origen" | "destino" | "modoEntrega") {
        if (type === "origen") {
            const ciudadOrigenData: CIUDAD = ciudadesOrigenStore.info.filter(el => el.id === Number(e.target.value))[0]
            if(ciudadOrigenData.id){
                setGuia({
                    ...guia,
                    idCiudadDestino: 0,
                    idCiudadOrigen: ciudadOrigenData.id,
                    CIUDAD_ORIGEN: ciudadOrigenData
                })
            }
        }

        if (type === "destino") {
            const ciudadDestinoData: CIUDAD = ciudadesDestinoStore.info.filter(el => el.id === Number(e.target.value))[0]
            if(ciudadDestinoData && ciudadDestinoData.id){
                setGuia({
                    ...guia,
                    idCiudadDestino: ciudadDestinoData.id,
                    CIUDAD_DESTINO: ciudadDestinoData
                })
            }
        }

        if (type === "modoEntrega") {
            if (e.target.value === LogisticaTiposEntrega.Domicilio) {
                setGuia({
                    ...guia,
                    tipoEntrega: LogisticaTiposEntrega.Domicilio
                })
            }
            if (e.target.value === LogisticaTiposEntrega.RetiroOficina) {
                setGuia({
                    ...guia,
                    tipoEntrega: LogisticaTiposEntrega.RetiroOficina
                })
            }
        }
    }
}

export default CiudadesYModoEntrega
